import React from "react";
import {
  LayoutDashboard,
  FolderTree,
  Package,
  MessageSquareText,
  LogOut,
} from "lucide-react";

interface Props {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  onLogout: () => void;
}

export const AdminSidebar: React.FC<Props> = ({
  activeTab,
  setActiveTab,
  onLogout,
}) => {
  const menuItems = [
    { id: "dashboard", label: "Tổng quan", icon: LayoutDashboard },
    { id: "categories", label: "Danh mục", icon: FolderTree },
    { id: "products", label: "Sản phẩm", icon: Package },
    { id: "contacts", label: "Yêu cầu liên hệ", icon: MessageSquareText },
  ];

  return (
    <aside className="w-64 bg-gray-900 text-gray-300 flex flex-col min-h-screen">
      <div className="p-6 border-b border-gray-800">
        <h1 className="text-lg font-bold text-white tracking-wider">
          RICE EXPORT
        </h1>
        <p className="text-xs text-emerald-400 mt-0.5">Admin Management</p>
      </div>

      <nav className="flex-1 px-4 py-6 space-y-1">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition duration-150 ${
                isActive
                  ? "bg-emerald-600 text-white shadow-lg"
                  : "text-gray-400 hover:bg-gray-800 hover:text-white"
              }`}
            >
              <Icon size={18} />
              {item.label}
            </button>
          );
        })}
      </nav>

      <div className="p-4 border-t border-gray-800">
        <button
          onClick={onLogout}
          className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium text-red-400 hover:bg-red-500/10 transition"
        >
          <LogOut size={18} />
          Đăng xuất
        </button>
      </div>
    </aside>
  );
};
